import LoadingButton from '@mui/lab/LoadingButton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';

type ApplicationCardProps = {
  applicationDescription: string;
  defaultImage?: string;
  description: string;
  id: string;
  testId?: string;
};

const ApplicationCard = ({
  applicationDescription,
  defaultImage,
  description,
  id,
  testId,
}: ApplicationCardProps): JSX.Element => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const viewApplicationClicked = (vehicleId: string): void => {
    navigate(`/dashboard/application/${vehicleId}`);
  };

  return (
    <li data-testid={testId}>
      <Card raised={false}>
        <figure>
          <CardMedia
            alt={description}
            component={'img'}
            image={defaultImage || VehicleImagePlaceholder}
          />
        </figure>
        <CardContent>
          <h3>{description}</h3>
          <h4>{applicationDescription}</h4>
          <LoadingButton
            color="primary"
            endIcon={<></>}
            loadingPosition="end"
            type="button"
            variant="contained"
            fullWidth
            onClick={() => {
              viewApplicationClicked(id);
            }}
          >
            {t('DashboardGaragePage.view')}
          </LoadingButton>
        </CardContent>
      </Card>
    </li>
  );
};

export default ApplicationCard;
